module.exports = __webpack_public_path__ + "img/admin_apply02.c5f418af.png";